import Color from 'color';
export const convertToLightRgba = (color) => color ? Color(color).lighten(0.2).rgb().string() : null;
//# sourceMappingURL=convertToLightRgba.js.map